import { PFDocStandardIngredientsDTO } from 'business/models/Models';
import React from 'react';
import {
  getIngIdStockNumber,
  getIngNameByIngId,
  getIngredientStock,
  getIngredientTypeName,
  isNullOrUndefined,
  padZeros,
} from 'utils/Global';
import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import {
  actionButtonsEnable,
  actionButtonStyle,
  iconSize,
} from './ProteinVariant/Constants';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';

type StandardIngCardProps = {
  onEditIngredient?: any;
  onDeleteIngredient?: any;
  ingredientData?: PFDocStandardIngredientsDTO;
  isReadOnly?: boolean;
};

export function StandardIngredientCard({
  onEditIngredient = null,
  onDeleteIngredient,
  ingredientData,
  isReadOnly,
}: StandardIngCardProps) {
  const stockData = getIngredientStock(ingredientData.ingredientStockId);
  const highphStock = getIngredientStock(ingredientData.highPhingredientStockId);

  return (
    <div  id='stdingredientcard-wrapper' className="w-[100%] mb-[0.5rem] border border-solid content-center justify-items-center border-[#888888] rounded-[4px]">
      <div id='stdingredientcard-container' className="w-[95%] mt-[2%] mb-[1%] flex flex-row justify-between">
        <div id='stdingredientcard-icon-container' className="w-[9.7%] h-[100%]">
          <RMSvgIcon
            id='stdingredientcard-svg-ingtubes-icon'
            name="IngredientTubes"
            fill="#414042"
            height="2.25rem"
            width="2.25rem"
          />
        </div>
        <div  id='stdingredientcard-content' className="w-[65%] flex flex-col">
          <div id='stdingredientcard-ingredientname' className="text-[1.077rem] text-[#1B1B1B] font-bold">
            {isNullOrUndefined(stockData)
              ? null
              : `${getIngNameByIngId(stockData.ingredientId)}`}
          </div>
          <div id='stdingredientcard-ingredienttype' className="text-[#313131] text-[0.923rem] font-[500]">
            {isNullOrUndefined(stockData)
              ? null
              : `${getIngredientTypeName(ingredientData.ingredientIngredientTypeId)}`}
          </div>
          <div id='stdingredientcard-concentration' className="text-[#5D5D5D] text-[0.923rem]">
            Conc.{' '}
            {isNullOrUndefined(ingredientData.concentration)
              ? 0
              : ingredientData.concentration.toFixed(2)}{' '}
            {stockData.concentrationUnits},{' '}
            {ingredientData.pH ? `pH ${ingredientData.pH}` : ''}
          </div>

          {stockData.isBuffer ? (
            <>
              <div id='stdingredientcard-bufferstock-main' className="text-[#5D5D5D] text-[0.923rem]">
                Stock {stockData.stockConcentration} {stockData.concentrationUnits}, pH{' '}
                {stockData.stockPh}{' '}
                {getIngIdStockNumber(stockData.ingredientId, stockData.stockNumber)}
              </div>
              {highphStock && (
                <div id='stdingredientcard-bufferstock-highph' className="text-[#5D5D5D] text-[0.923rem]">
                  Stock{' '}
                  {!isNullOrUndefined(highphStock) && highphStock.stockConcentration}{' '}
                  {!isNullOrUndefined(highphStock) && highphStock.concentrationUnits}, pH{' '}
                  {highphStock?.stockPh}{' '}
                  {!isNullOrUndefined(highphStock) &&
                    getIngIdStockNumber(
                      highphStock.ingredientId,
                      highphStock.stockNumber,
                    )}
                </div>
              )}
            </>
          ) : (
            <div id='stdingredientcard-stockinfo' className="text-[#5D5D5D] text-[0.923rem]">
              Stock {padZeros(stockData.stockNumber, 3)} {stockData.stockConcentration}{' '}
              {stockData.concentrationUnits}{' '}
              {getIngIdStockNumber(stockData.ingredientId, stockData.stockNumber)}
            </div>
          )}
        </div>
        <div id='stdingredientcard-actions' className="w-[19.4%] flex flex-row justify-between">
          <RMCustomButton
            onClick={() => {
              onDeleteIngredient();
            }}
            isDisabled={isReadOnly}
            titleTip={'Delete'}
            iconProps={{ name: 'Delete', fill: 'white', ...iconSize }}
            contentContainerStyle={{
              ...actionButtonStyle,
              backgroundColor: actionButtonsEnable.delete,
            }}
            mainContainerClass="place-content-start"
          />
          <RMCustomButton
            onClick={() => {
              onEditIngredient();
            }}
            isDisabled={isReadOnly}
            titleTip={'Edit'}
            iconProps={{ name: 'Edit', fill: 'white', ...iconSize }}
            contentContainerStyle={{
              ...actionButtonStyle,
              backgroundColor: actionButtonsEnable.edit,
            }}
            mainContainerClass="place-content-start"
          />
        </div>
      </div>
    </div>
  );
}
